import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function Header({ setActiveTab }) {
  return (
    <header className="h-16 border-b border-[#333] bg-charcoal-panel/80 backdrop-blur-md flex items-center justify-between px-6 sticky top-0 z-10">
      <div className="flex items-center gap-4 md:hidden">
         <div className="w-8 h-8 rounded-lg bg-invoice-green flex items-center justify-center flex-shrink-0">
            <SafeIcon name="Hexagon" className="w-5 h-5 text-[#111]" />
          </div>
      </div>
      
      <div className="hidden md:flex flex-1 max-w-md relative">
        <SafeIcon name="Search" className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-cream-muted" />
        <input 
          type="text" 
          placeholder="Search clients, projects, or invoices... (Cmd+K)" 
          className="w-full bg-charcoal-base border border-[#333] rounded-lg pl-9 pr-4 py-1.5 text-sm text-cream focus:outline-none focus:border-invoice-green transition-colors"
        />
      </div>

      <div className="flex items-center gap-4 ml-auto">
        <button className="relative p-2 text-cream-muted hover:text-cream transition-colors">
          <SafeIcon name="Bell" className="w-5 h-5" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-invoice-green rounded-full border border-charcoal-panel"></span>
        </button>
        <button className="md:hidden p-2 text-cream-muted" onClick={() => setActiveTab('menu')}>
          <SafeIcon name="Menu" className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
}